import * as ClientConfig from "../../config/ClientConfig.js";
import * as StorageService from "../StorageServices.js";
import { LOCALSTORAGE_ITEMS } from "../../util/Constants";
import { handleAuthEmptyResponse, handleAuthResponse } from "../../util/api/restClient";

/**
 * Helper: build query string, supporting arrays (repeat key).
 * Example: { statuses: ["DRAFT","COMPLETED"], sort: ["created,DESC"] }
 * => ?statuses=DRAFT&statuses=COMPLETED&sort=created,DESC
 */
const toQueryString = (params = {}) => {
  const sp = new URLSearchParams();

  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;

    if (Array.isArray(v)) {
      v.filter((x) => x !== undefined && x !== null && x !== "").forEach((x) => sp.append(k, String(x)));
      return;
    }

    sp.append(k, String(v));
  });

  const qs = sp.toString();
  return qs ? `?${qs}` : "";
};

const authHeaders = () => ({
  "Content-Type": "application/json",
  "Authorization": "Bearer " + StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
});

// ============================
// GET /api/location-inspection-form
// ============================
const getAllLocationInspectionForms = async (queryParams) => {
  return handleAuthResponse(() => {
    const finalURL =
      ClientConfig.URL_RESOURCE_SERVER +
      "/api/location-inspection-form" +
      toQueryString(queryParams);

    return fetch(finalURL, {
      method: "GET",
      headers: authHeaders(),
    });
  });
};

// ============================
// GET /api/location-inspection-form/me
// ============================
const getMyLocationInspectionForms = async (queryParams) => {
  return handleAuthResponse(() => {
    const finalURL =
      ClientConfig.URL_RESOURCE_SERVER +
      "/api/location-inspection-form/me" +
      toQueryString(queryParams);

    return fetch(finalURL, {
      method: "GET",
      headers: authHeaders(),
    });
  });
};

// ============================
// POST /api/location-inspection-form
// ============================
const createLocationInspectionForm = async (body) => {
  return handleAuthResponse(() => {
    const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/location-inspection-form";
    return fetch(finalURL, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(body),
    });
  });
};

// ============================
// GET /api/location-inspection-form/{id}
// ============================
const getLocationInspectionFormById = async (id) => {
  return handleAuthResponse(() => {
    const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/location-inspection-form/" + id;
    return fetch(finalURL, {
      method: "GET",
      headers: authHeaders(),
    });
  });
};

// ============================
// PUT /api/location-inspection-form/{id}
// ============================
const editLocationInspectionFormById = async (id, body) => {
  return handleAuthResponse(() => {
    const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/location-inspection-form/" + id;
    return fetch(finalURL, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(body),
    });
  });
};

// ============================
// DELETE /api/location-inspection-form/{id}
// (Swagger says 200 OK with no content schema -> use handleAuthEmptyResponse)
// ============================
const deleteLocationInspectionFormById = async (id) => {
  return handleAuthEmptyResponse(() => {
    const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/location-inspection-form/" + id;
    return fetch(finalURL, {
      method: "DELETE",
      headers: authHeaders(),
    });
  });
};

export {
  getAllLocationInspectionForms,
  getMyLocationInspectionForms,
  createLocationInspectionForm,
  getLocationInspectionFormById,
  editLocationInspectionFormById,
  deleteLocationInspectionFormById,
};
